// extracted by mini-css-extract-plugin
module.exports = {"bannercard":"bannercard_bannercard__vJ6zd"};